import {selectTheme} from '../../store'

export const Toggle = (props: {enabled: boolean; onChange: (enabled: boolean) => void; disabled?: boolean}) => {
  const {enabled, onChange, disabled} = props
  const {color} = selectTheme()
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return
    onChange(e.target.checked)
  }

  return (
    <label
      css={{
        width: '28px',
        height: '16px',
        borderRadius: '100px',
        border: `2px solid`,
        borderColor: disabled ? color.border.disabled : enabled ? color.textIcon.link : color.textIcon.secondary,
        backgroundColor: disabled ? color.border.disabled : enabled ? color.textIcon.link : color.textIcon.secondary,
      }}>
      <input
        css={{display: 'none'}}
        {...{
          type: 'checkbox',
          checked: enabled,
          disabled,
          onChange: handleChange,
        }}
      />
      <div
        css={{
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          backgroundColor: color.white,
          transform: enabled ? 'translateX(12px)' : 'translateX(0)',
          transition: 'transform .3s ease-in-out',
        }}
      />
    </label>
  )
}
